<template>
  <smd-one-col-layout class="doctors-page"
                      content-styles="reset-mp">
    <smd-header class="doctors-page__header top-bar-box-shadow"
                slot="header"
                v-if="hideTabs">
      <img alt="nowserving logo"
           class="crisp-image"
           src="../../assets/images/nowserving.png"
           slot="left-actions"
           v-if="$isMobile"
           width="123px">

      <smd-fixed-tab-panel v-else
                           :options="computedTabOptions"
                           slot="left-actions"/>
      <template slot="right-actions">
        <div class="flex-row-center-xy-spaced">
          <smd-btn type="button"
                   v-if="!$isMobile"
                   @click="doctorSearch">
            <text-string label-id="txt012"/>
          </smd-btn>
          <smd-btn class="icon-btn"
                   icon="ns-icon-settings"

                   @click="goToSettings">
          </smd-btn>
        </div>
      </template>
    </smd-header>
    <smd-fixed-tab-panel v-if="hideTabs && $isMobile"
                         :options="computedTabOptions"
                         slot="toolbar"/>
    <router-view/>
  </smd-one-col-layout>
</template>

<script>
  import HeaderFunctionMixin from '@/mixins/header-functions-mixin'

  import Routes from '@/router/routes';

  export default {
    name: 'doctors-page',
    mixins: [HeaderFunctionMixin],
    computed: {
      computedTabOptions() {
        return this.$isMobile ? this.$options.menu : this.desktopMenu;
      },
      desktopMenu() {
        return this.$options.menu.filter(item => item.name !== 'Find a Doctor')
      },
      hideTabs() {
        const pagesToHideFrom = [
          Routes.DOCTOR_ROUTE,
          Routes.APPOINTMENT_NEW_REQUESTS_ROUTE,
          Routes.APPOINTMENT_APPROVED_ROUTE,
          Routes.APPOINTMENT_PENDING_ROUTE,
          Routes.APPOINTMENT_DENIED_ROUTE,
        ];

        return !pagesToHideFrom.includes(this.$route.name);
      },
    },
    methods: {
      doctorSearch() {
        window.open('https://nowserving.ph/', '_blank');
      },
    },
    menu: [
      {name: 'Consultations', to: {name: Routes.APPOINTMENTS_ROUTE}},
      {name: 'Find a Doctor', to: {name: Routes.DOCTOR_SEARCH_ROUTE}},
      {name: 'My Doctors', to: {name: Routes.DOCTORS_ROUTE_LIST}},
    ],
    created() {
      if (this.$route.name === Routes.DOCTORS_ROUTE)
        this.$router.push({name: Routes.APPOINTMENTS_ROUTE});
    },
    beforeRouteUpdate(to, from, next) {
      this.$nextTick(() => {
        if (to.name === Routes.DOCTORS_ROUTE)
          next({name: Routes.APPOINTMENTS_ROUTE});
      })

      next()
    }
  }
</script>
<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .doctors-page__tab {
    padding: space(s) space(base);
  }

  .doctors-page__header {
    @include responsive(tablet, "ipad") {
      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
    @include responsive(desktop) {

      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
  }
</style>